import {
  IList,
  ListByIdsResponseDto,
} from '@epicuro-next/data/engagement/engagement-models';
import { decode } from 'html-entities';

// When delete mapping - move decode logic to other place (map in service response)
export function mapListByIdsToLegacy(lists: IList[]): ListByIdsResponseDto[] {
  return lists.map(
    ({
      id,
      mainMedia: media,
      name,
      newsfeedId,
      lookBookIdsPromotedIn,
      recipients,
      createdAtUtc,
    }) =>
      ({
        id,
        media,
        name: decode(name),
        newsfeedId,
        lookBookIdsPromotedIn,
        recipientsCount: recipients?.count,
        createdAtUtc,
      } as ListByIdsResponseDto),
  );
}
